module.exports = require(55)('native-function-to-string', Function.toString);
